// TSS vite/03 §"Query keys convention".

export const userKeys = {
    all:    ['users'],
    list:   (filters) => ['users', 'list', filters],
    detail: (id)      => ['users', 'detail', id],
};
